import {
 Component,
 computed,
 EventEmitter,
 Inject,
 inject,
 Input,
 OnChanges,
 Output,
 PLATFORM_ID,
 SimpleChanges,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { SharedModule } from '@shared/shared.module';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { WebengageService } from '@core/services/webengage.service';
import { MomentService } from '@core/services/moment.service';

@Component({
 selector: 'iho-pdp-price-details',
 standalone: true,
 imports: [CommonModule, SharedModule],
 templateUrl: './pdp-price-details.component.html',
 styleUrls: ['./pdp-price-details.component.scss'],
})
export class PdpPriceDetailsComponent {
 loading = false;
 updatingPrices = computed(
  () => this.datepickerService.isNextMonthLoading() || this.datepickerService.isPrevMonthLoading()
 );
 constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

 isMobile: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(window.navigator.userAgent)
  : undefined;
 pdpUiService = inject(HotelInfoUiService);
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 webengageService = inject(WebengageService)
 momentService = inject(MomentService)

 @Input() priceDetails?: any;
 @Output() isShowToast = new EventEmitter<boolean>();
 goToFollowReservation() {
  if (this.pdpUiService.FixedGuestCount() == 0) {
   this.isShowToast.emit(true);
   return;
  }

  if (
   this.datepickerService.calenderErrors().NonBookable ||
   this.datepickerService.calenderErrors().NightLimits
  ) {
   return;
  }

  this.loading = true;
  const _payload = {
   hotelId:
    this.pdpUiService.hotelInfo().Type == 2 ? this.pdpUiService.hosueId : this.pdpUiService.hotelId,
   arrivalDate: this.datepickerService._startDateShab(),
   checkoutDate: this.datepickerService._endDateShab(),
   rooms: this.pdpUiService.ecolodgeRoomInfo(),
   type: this.pdpUiService.hotelInfo().Type,
   IsWaitingList: false,
   organizationId: null,
   Combenations: [],
   ExtraGuestCount: this.pdpUiService.ExtraGuestCount(),
   FixedGuestCount: this.pdpUiService.FixedGuestCount(),
   AccommodationType: this.searchBoxService.accommodation() == 'ecolodge' ? 2 : 1,
  };

  this.pdpUiService.getReserveUUID(_payload).subscribe((uuid) => {
   if (uuid) {
    this.webengageService.trackIntrack('Room-Select', {
    CheckInDate: this.momentService.toGergorian(this.datepickerService._startDate()),
    CheckOutDate: this.momentService.toGergorian(this.datepickerService._endDate()),
    Destination: this.pdpUiService?.hotelInfo()?.HotelHeader.Address.CityName,
    hotelName: this.pdpUiService?.hotelFullName,
    HotelId: this.pdpUiService.hotelInfo().Type == 2 ? this.pdpUiService.hosueId : this.pdpUiService.hotelId,
    Price: 0,
    RoomName: '',
    RoomNumber: 0,
    numberOfNights: this.pdpUiService?.nights,
    hotelType: this.pdpUiService?.hotelInfo()?.HotelHeader?.TypeName ?? '',
    hotelRate: +this.pdpUiService?.hotelInfo()?.HotelHeader?.Score?.ScoreNumber,
    hotelGrade: this.pdpUiService.hotelInfo()?.HotelHeader?.Star?.GradeId || 0,
    roomCapacity: 0,
  });
       window.location.href = window.location.origin + '/persian/pursuit/' + uuid;
       this.loading = false;
   }
  });
 }
}
